
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__dislike_finger",
  "use": "icon__dislike_finger-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon__dislike_finger\"><path d=\"M10.688 18.747a.622.622 0 0 0 .586-.625v-1.094c0-1.504.41-2.603.742-3.281h5.508V2.497H4.164c-.893 0-1.68.61-1.874 1.48 0 .014-.005.033-.005.048L1.279 11.53l.014-.059c-.258 1.167.674 2.276 1.87 2.276h4.36v2.187c0 1.397.86 2.236 1.642 2.549.78.317 1.523.264 1.523.264zm-.664-1.348c-.166-.025-.205.005-.39-.068-.47-.196-.86-.45-.86-1.397v-2.812a.623.623 0 0 0-.625-.625H3.164c-.45 0-.738-.357-.655-.752l.015-.054.991-7.451a.652.652 0 0 1 .65-.493h7.109v8.725c-.283.435-1.25 2.1-1.25 4.556v.37zm6.25-4.902h-3.75v-8.75h3.75v8.75zm-1.875-6.25a.623.623 0 0 0 .625-.625.623.623 0 0 0-.625-.625.623.623 0 0 0-.625.625c0 .346.278.625.625.625z\" fill=\"currentColor\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconDislikeFingerIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__dislike_finger" {...restProps} />
    })
  